import React from 'react'
import { LIST_ROUTER_MENU_MOBILE, VNTRIP_INFO } from '../../constants/common'
import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { toggleSidebarMobile } from '../../redux/actions/common-action'
import {IconAboutVntrip, IconContact, IconHeadPhone, IconMail, IconPhone} from '../../constants/icons'

const MenuMobile = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const isOpenSideBar = useSelector((state: any) => state.commonReducer.isOpenSideBar)
    const closeSideBar = () => {
        dispatch(toggleSidebarMobile(false))
        document.body.classList.remove('noScroll')
    }
    const handleClickLink = ({ link, isOpenNewTab }: any) => () => {
        closeSideBar()
        if (isOpenNewTab) {
            if (typeof window !== 'undefined') {
                window.open(`${link}`)
            }
        } else {
            history.push({
                pathname: link,
            })
        }
    }
    return (
        <div className={`menuMobile ${isOpenSideBar ? 'open' : ''}`}>
            <div className="menuMobile__cont">
                <div className="menuMobile__header">
                    <div className="menuMobile__avatar">
                        <img src="https://statics.vntrip.vn/images/default-avatar.png" alt="avatar" />
                    </div>
                </div>
                <div className="menuMobile__body">
                    <ul className="menuMobile__list">
                        {LIST_ROUTER_MENU_MOBILE.map(({ key, label, link, isOpenNewTab, icon: Icon }) => {
                            return (
                                <li key={key}>
                                    <button onClick={handleClickLink({ key, label, link, isOpenNewTab })}>
                                        <Icon />
                                        <span>{label}</span>
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                    <ul className="menuMobile__list">
                        <li>
                            <a href="https://www.vntrip.vn/ve-vntrip">
                                <IconAboutVntrip />
                                <span>Về Vntrip</span>
                            </a>
                        </li>
                        <li>
                            <a onClick={closeSideBar} href="https://www.vntrip.vn/lien-he">
                                <IconContact />
                                <span>Liên hệ</span>
                            </a>
                        </li>
                        <li>
                            <a href={`mailto:${VNTRIP_INFO.email}`}>
                                <IconMail />
                                <span>{VNTRIP_INFO.email}</span>
                            </a>
                        </li>
                        <li>
                            <a href={`tel:${VNTRIP_INFO.hotline}`}>
                                <IconPhone />
                                <span>{VNTRIP_INFO.hotline}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                role={'button'}
                tabIndex={0}
                onClick={closeSideBar}
                onKeyUp={closeSideBar}
                className="menuMobile__backdrop"
            />
        </div>
    )
}

export default MenuMobile
